<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Landed Cost</h4>
                <p class="text-subtitle-1">Landed Cost List</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(permissions.landed_cost.create)">
                <v-btn block color="primary" @click="onNew">
                    <v-icon left>mdi-plus</v-icon>
                    new landed cost
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            block
                            depressed
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            Search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-form>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="Code"
                                            dense
                                            outlined
                                            hide-details="auto"
                                            v-model="search.code"
                                            clearable/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <DatePicker
                                            dense
                                            outlined
                                            label="From"
                                            hide-details="auto"
                                            v-model="search.from"
                                            clearable/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <DatePicker
                                            dense
                                            outlined
                                            label="To"
                                            hide-details="auto"
                                            v-model="search.to"
                                            clearable/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            dense
                                            outlined
                                            label="Warehouse"
                                            hide-details="auto"
                                            v-model="search.warehouse_id"
                                            :items="warehouses"
                                            item-text="display_name"
                                            item-value="id"
                                            @update:search-input="searchWarehouses"
                                            clearable/>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-autocomplete
                                            dense
                                            outlined
                                            label="State"
                                            :items="states"
                                            hide-details="auto"
                                            v-model="search.state_code"
                                            clearable/>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" block @click="handleSearch">Search</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :loading="loading"
                    disable-sort
                    >

                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleOpen(item.id)" v-if="hasPermission(permissions.landed_cost.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <span class="font-weight-bold">
                            {{ item.code }}
                        </span>
                    </template>

                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import service from './../../services/purchase/landedCost';
import PStatus from '../../components/common/PStatus.vue';
import DatePicker from '../../components/common/DatePicker.vue';
import warehouse from '../../services/purchase/warehouse';
import landedCost from './../../services/purchase/landedCost';
import authorize from '../../utils/authorize';
import permissions from '../../data/permissions';

export default {
    components: {
        PStatus,
        DatePicker
    },
    data() {
        return {
            page: 1,
            serverItemsLength: 0,
            loading: false,
            options: {},
            search: {
                code: null,
                state_code: null,
                from: null,
                to: null,
                warehouse_id: null
            },
            data: [],
            warehouses: [],
            warehousesLoading: false,
            states: [],
            permissions
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        }
    },
    computed: {
        headers() {
            return [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Warehouse", value: "warehouse" },
                { text: "Created By", value: "created_by" },
                { text: "State", value: "state" }
            ]
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code);
        },
        fetch() {
            this.data = [];
            this.loading = true;
            service.index({...this.options, ...this.search}).then(res => {
                this.data = res.data.data;
                this.serverItemsLength = res.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleOpen(id) {
            this.$router.push({
                name: "LandedCostDisplay",
                params: {
                    id
                }
            })
        },
        onNew() {
            this.$router.push({
                name: "LandedCostCreate"
            })
        },
        searchWarehouses(query) {
            this.warehousesLoading = true;
            warehouse.search(query).then(res => {
                this.warehouses = [...this.warehouses, ...res.data];
            }).finally(() => {
                this.warehousesLoading = false;
            })
        },
        fetchStates() {
            landedCost.states().then(res => {
                this.states = res.data;
            })
        },
        handleSearch() {
            this.page = 1;
            this.fetch();
        }
    },
    created() {
        this.fetchStates();
    }
}
</script>

<style>

</style>